//@flow
import React from 'react';
import { observer, inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import { Switch } from 'react-router-dom';
import reactHtmlParser from 'react-html-parser';
import GwuHeader from '../components/core/GwuHeader';
import GwuLandingHeader from '../components/core/GwuLandingHeader';
import GwuFooter from '../components/core/GwuFooter';
import Loading from '../components/core/Loading';
import Notification from '../components/core/Notification'
import PrivateRoute from '../components/core/PrivateRoute';
import type { Match, Location, RouterHistory } from 'react-router-dom';
import ReactGA from 'react-ga';
import authenticatedRoutes from '../authenticatedRoutes';
import { isProd, application } from '../config';
import { remCalc, getXLMediaQueriedStyle } from '../util/style-util';
import FeedbackUtil from '../util/feedback-util';

type Props = {
  userStore: any,
  languageStore: any,
  notificationStore: any,
  location: Location,
  match: Match,
  history: RouterHistory,
  classes: Object
};

const HOME_PATH = '/';
const PILOT_PATH = '/pilot';

class AuthenticatedRouteContainer extends React.Component<Props> {
  handleLogout = () => {
    this.props.userStore.logout();
  }

  handleViewOnBoarding = () => {
    this.props.userStore.reopenOnBoarding();
  }

  showQuotes = () => {
    const path = window.location.pathname;
    const { isManaged } = this.props.userStore;

    return (isManaged && (path === '/' || path.startsWith('/pathway/')));
  }

  simpleFooter = () => {
    const path = window.location.pathname;

    return (path.startsWith('/admin'));
  }

  renderHeader = () => {
    const { isAuthenticated } = this.props.userStore;

    if (!isAuthenticated) {
      return;
    }

    const { history } = this.props;
    const { pathname } = this.props.location;
    const { user, userLanguage, isAnonymous } = this.props.userStore;
    const { lang } = this.props.languageStore;
    const showLogout = !isProd && application !== 'gwu' && !isAnonymous; // gwu-local and gwu-dev is fine

    ReactGA.pageview(window.location.pathname + window.location.search);

    if ([HOME_PATH, PILOT_PATH].includes(pathname)) {
      const isPilotPage = (PILOT_PATH === pathname);
      const heroLabel = isPilotPage ? 'pilot.hero' : 'home.hero.text';
      const heroText = reactHtmlParser(lang.t(heroLabel));

      const onPilotLaunch = isPilotPage ? () => { history.push('/') } : null;

      return (
        <GwuLandingHeader
          userProfile={user}
          userLanguage={userLanguage}
          history={history}
          showLogout={showLogout}
          onLogout={this.handleLogout}
          onViewOnBoarding={this.handleViewOnBoarding}
          heroText={heroText}
          onPilotLaunch={onPilotLaunch}
          lang={lang}
        />
      );
    }

    return (
      <GwuHeader
        userProfile={user}
        history={history}
        showLogout={showLogout}
        onLogout={this.handleLogout}
        onViewOnBoarding={this.handleViewOnBoarding}
        lang={lang}
      />
    );
  }

  renderNotificationContainer() {
    const { open, message, onClose, durationMs } = this.props.notificationStore;

    return (
      <Notification
        open={open}
        message={message}
        onClose={onClose}
        durationMs={durationMs}
      />
    );
  }

  renderFeedback() {
    const { userLanguage } = this.props.userStore;
    return FeedbackUtil.getFeedbackForm(userLanguage);
  }


  render() {
    const { match, history, classes } = this.props;
    const { user, isAuthenticated, ssoUrl, isFetchingUserProfile } = this.props.userStore;
    const { isFetchingLang, lang } = this.props.languageStore;

    if (isFetchingUserProfile || isFetchingLang) {
      return (
        <Loading />
      );
    }

    const handleTermsClick = () => {
      history.push('/terms');
    }

    // {this.renderFeedback()}

    return (
      <div className={classes.container}>
        {this.renderHeader()}
        {this.renderNotificationContainer()}
        <section>
          <Switch>
            {authenticatedRoutes.map(route => {
              return (
                <PrivateRoute
                  path={`${match.path}${route.path}`}
                  component={route.component}
                  isAuthenticated={isAuthenticated}
                  canAccess={route.canAccess}
                  ssoUrl={ssoUrl}
                  userProfile={user}
                  key={route.path}
                />
              )
            })}
          </Switch>
        </section>
        <GwuFooter
          simple={this.simpleFooter()}
          showQuotes={this.showQuotes()}
          onTermsClick={handleTermsClick}
          lang={lang}
        />
      </div>
    );
  }
}

const styles = {
  container: {
    ...getXLMediaQueriedStyle({
      width: remCalc(1440),
      margin: 'auto'
    })
  }
};

export default withStyles(styles)(inject('userStore', 'languageStore', 'notificationStore')(observer(AuthenticatedRouteContainer)));



// WEBPACK FOOTER //
// ./src/containers/AuthenticatedRouteContainer.js